export default __webpack_public_path__ + "static/media/icac.71c41ae3.jpg";